export const MENU_LINKS = [
  {
    title: 'Заявки',
    link: '/order'
  },
  {
    title: 'Контакты',
    link: '/contact'
  },
  {
    title: 'Контрагенты',
    link: '/customer'
  }
]
